import React from 'react';
import { Steps } from 'antd';
import Wrapper from './style';

const { Step } = Steps;

const Index = (props) => {
  const {
    stepsList = [],
    titleSteps = 'Title Steps',
    currentStep,
    children,
  } = props;

  return (
    <Wrapper>
      <div className="container_integrator_steps">
        <div className="font-header3_medium black2 component_title_steps">
          {titleSteps}
        </div>
        <Steps current={currentStep} className="component_steps">
          {stepsList.map((item) => {
            return (
              <Step key={item?.title} title={item?.title} icon={item?.icon} />
            );
          })}
        </Steps>
      </div>
      {children}
    </Wrapper>
  );
};

export default Index;
